import * as yup from 'yup';

type TranslateFunction = (key: string) => string;

export const createStep1Schema = (t: TranslateFunction) =>
  yup.object({
    telegram: yup
      .string()
      .required(t('createAccount.validation.telegramRequired'))
      .min(3, t('createAccount.validation.telegramMinLength')),
    contact: yup.string(),
  });

export const createStep2Schema = (t: TranslateFunction) =>
  yup.object({
    ofLink: yup
      .string()
      .trim()
      .required(t('createAccount.validation.ofLinkRequired'))
      .matches(
        /^https?:\/\/(www\.)?onlyfans\.com\/[a-zA-Z0-9._-]+$/,
        t('createAccount.validation.ofLinkInvalid')
      ),
  });

export type Step1FormData = yup.InferType<ReturnType<typeof createStep1Schema>>;
export type Step2FormData = yup.InferType<ReturnType<typeof createStep2Schema>>;
